import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Agent {
  id: number
  email: string
  is_admin: boolean
  agency_id: number | null
}

interface AuthStore {
  token: string | null
  agent: Agent | null
  setAuth: (token: string, agent: Agent) => void
  logout: () => void
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      token: null,
      agent: null,
      setAuth: (token, agent) => set({ token, agent }),
      logout: () => set({ token: null, agent: null }),
    }),
    { name: 'quidimo-auth' }
  )
)
